import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BadgeCheck, X } from 'lucide-react';
import api from '../api';

export const SignedAlertBanner = () => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { api.get('/signed-485-alerts').then(r => setAlerts(r.data.alerts || [])).catch(() => {}); }, []);

  const dismiss = async (a) => {
    setAlerts(list => list.filter(x => x.id !== a.id));
    await api.post(`/signed-485-alerts/${a.id}/dismiss`).catch(() => {});
    window.dispatchEvent(new Event('alerts-changed'));
  };
  const open = async (a) => {
    await dismiss(a);
    navigate(`/dashboard/patients/demographics/${a.patientId}?tab=signatures`);
  };

  if (!alerts.length) return null;
  return (
    <div className="space-y-2" data-testid="signed-alert-banner">
      {alerts.map(a => (
        <div key={a.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-green-300 bg-green-50 px-4 py-3" data-testid={`signed-alert-${a.id}`}>
          <BadgeCheck className="w-5 h-5 text-green-700 shrink-0" />
          <p className="flex-1 min-w-[14rem] text-sm text-green-900">
            <strong>485 signed:</strong> {a.signedName || 'The physician'} signed the CMS-485 for <strong>{a.patientName}</strong> on {new Date(a.signedAt).toLocaleString()}. The signed copy is in Application Packages.
          </p>
          <button onClick={() => open(a)} data-testid={`signed-alert-open-${a.id}`}
            className="px-3 py-1.5 rounded-full bg-green-700 text-white text-sm font-semibold hover:bg-green-800">Open</button>
          <button onClick={() => dismiss(a)} data-testid={`signed-alert-dismiss-${a.id}`} className="p-1 text-green-800 hover:text-green-950" title="Dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
